import React, { useCallback, useEffect, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AdminRoutes from "../../../routes/AdminRoutes";

const Options = () => {

    const slicedRoutes = AdminRoutes.slice(16, 25);
    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <div className={styles.formContainer}>
                  <div className={styles.cardRow}>
                  {slicedRoutes.map((item, index) => (
                    <Link to={`/admin/${item.path}`} className={styles.linkText}>
                    <div key={index} className={styles.linkCard}>{item.name}</div></Link>
                  ))}
                  </div>
                </div>
            </div>
        </div>
    );
};

export default Options;
